import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { HomeUI } from './HomeUI'
import { useHome } from './useHome'

export const HomePage = () => {
  const history = useHistory()
  const props = useHome()

  useEffect(() => {
    const isAspaecHome =
      window.location.hostname === 'sistema.aspaec.com' &&
      (window.location.pathname === '/' || window.location.pathname === '')
    if (isAspaecHome) {
      history.replace('/AreaAssociados')
    }
  }, [history])

  return <HomeUI {...props} />
}
